import styled from "styled-components"
import Colors from "utils/Colors"

export default styled.div`
background-color: ${Colors.white};
min-height: 150px;
border-radius: 10px;
width: 90vw;
height: 90vh;
padding: 2rem 3rem 3rem;
position: absolute;
top: 50%;
left: 50%;
transform: translate(-50%, -50%);
outline: none;
font-size: 14px;
`
export const TitleBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 1rem;
  & .close-button {
    font-size: 30px;
  }
`
export const Content = styled.div`
  width: 100%;
  max-height: 75vh;
  min-height: 75vh;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 1rem;
  overflow-y: auto;
  padding: 0 1rem;
  
  &::-webkit-scrollbar {
    width: 10px;
  }
  
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${Colors.loginLigthenPrimaryColor};
    border-radius: 10px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: ${Colors.loginPrimaryColor};
  }
    
  & .issue-container {
    padding: 0 2rem;
    width: 100%;
    & p {
      padding: 5px 0 0 5px;

      & span {
        font-weight: 600;
      }
    }
  }
  
  & .MuiAccordion-root {
    width: calc(100% - 2px);
  }
`

